import { create } from 'zustand';
import { UserNotification } from '../models/UserNotification';

interface NotificationStore {
	receivedNotifications: UserNotification[];
	unreadNotificationCount: number;
	updateNotifications: (newReceivedNotification: UserNotification) => void;
	setUnreadNotificationCount: (count: number) => void;
}

const useNotificationStore = create<NotificationStore>((set) => ({
	receivedNotifications: [],
	unreadNotificationCount: 0,

	updateNotifications: (newReceivedNotification: UserNotification) => {
		set((state) => {
			const updated = state.receivedNotifications.filter(
				(n) => n.userNotificationId !== newReceivedNotification.userNotificationId
			);

			return { receivedNotifications: [...updated, newReceivedNotification] };
		});
	},

	setUnreadNotificationCount: (count: number) => {
		set({ unreadNotificationCount: Math.max(0, count) });
	}
}));

export default useNotificationStore;
